import { Link } from "react-router-dom";

interface Props {
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  accent?: "primary" | "accent";
}

export default function SectionHeading({ title, desc, moreTo, moreLabel = "查看更多", accent = "accent" }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-3.5 md:mb-4">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 font-heading text-[19px] md:text-[21px] font-black text-foreground-900">
          <span
            className={`w-1 h-5 rounded-full ${accent === "accent" ? "bg-accent-500" : "bg-primary-500"}`}
            aria-hidden="true"
          />
          {title}
        </h2>
        {desc && <p className="text-[12.5px] text-foreground-500 mt-1.5 hidden sm:block">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-[13px] text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}